import { finish, error } from '../../../modules/customers/actions/reactivate';

import api from '../../../api';

export function request(dispatch, { id }) {
    api.post('/customers/' + id + '/reactivate').then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, customer)),
            () => dispatch(finish(id))
        ),
        ({ errors }) => dispatch(error(id, errors))
    );
}
